import { useState } from 'react';
import Skill from './Skill';
import faehigkeitenDaten from '../data/mySkills.json';
import stile from './Skills.module.css';
import { useSprache } from '../sprache';
import { AdministrationIcon, EntwicklungIcon, ErfahrungIcon, WissenIcon, ZertifikatIcon } from './LinienIcons';

function Skills({ showPopup, setShowPopup, tech, setTech, setSelectedCardRect }) {
  // Aktiver Filter-Zustand: alle, development oder administration
  const [aktiveKategorie, setAktiveKategorie] = useState('all');
  const { t } = useSprache();

  const entwicklungsFaehigkeiten = faehigkeitenDaten.filter((kompetenz) => kompetenz.category === 'development');
  const administrationsFaehigkeiten = faehigkeitenDaten.filter((kompetenz) => kompetenz.category === 'administration');

  return (
    <section className={`${stile.skillsSection} scrollEnthuellung`} id="skills">
      <span className="abschnittsNummer">[01] {t('nav.kompetenzen')}</span>
      <h2 className={stile.mainTitle}>{t('skills.titel')}</h2>
      <p className={stile.subTitle}>
        {t('skills.untertitel')}
      </p>

      {/* Legende mit Pastell-Abzeichen */}
      <div className={stile.legendContainer}>
        <div className={stile.legendItem} title={t('skills.legendeErfahrungHinweis')}>
          <ErfahrungIcon groesse={18} />
          <span>{t('skills.legendeErfahrung')}</span>
        </div>
        <div className={stile.legendItem} title={t('skills.legendeWissenHinweis')}>
          <WissenIcon groesse={18} />
          <span>{t('skills.legendeWissen')}</span>
        </div>
        <div className={stile.legendItem} title={t('skills.legendeZertifikatHinweis')}>
          <ZertifikatIcon groesse={18} />
          <span>{t('skills.legendeZertifikat')}</span>
        </div>
      </div>

      {/* Interaktive Filter-Tabs */}
      <div className={stile.filterTabs}>
        <button
          type="button"
          className={`${stile.tabBtn} ${aktiveKategorie === 'all' ? stile.activeTab : ''}`}
          onClick={() => setAktiveKategorie('all')}
        >
          <span>{t('skills.tabAlle')}</span>
          <span className={stile.tabZaehler}>{faehigkeitenDaten.length}</span>
        </button>
        <button
          type="button"
          className={`${stile.tabBtn} ${aktiveKategorie === 'development' ? stile.activeTab : ''}`}
          onClick={() => setAktiveKategorie('development')}
        >
          <span>{t('skills.tabEntwicklung')}</span>
          <span className={stile.tabZaehler}>{entwicklungsFaehigkeiten.length}</span>
        </button>
        <button
          type="button"
          className={`${stile.tabBtn} ${aktiveKategorie === 'administration' ? stile.activeTab : ''}`}
          onClick={() => setAktiveKategorie('administration')}
        >
          <span>{t('skills.tabAdministration')}</span>
          <span className={stile.tabZaehler}>{administrationsFaehigkeiten.length}</span>
        </button>
      </div>

      {/* Entwicklungs-Bereich */}
      {(aktiveKategorie === 'all' || aktiveKategorie === 'development') && (
        <div className={stile.categoryBlock}>
          <div className={stile.categoryHeader}>
            <h3 className={stile.categoryTitle}>
              <span className={stile.categoryIcon}><EntwicklungIcon groesse={22} /></span>
              <span>{t('skills.kategorieEntwicklung')}</span>
            </h3>
            <span className={stile.categoryBadge}>{entwicklungsFaehigkeiten.length} {t('skills.technologien')}</span>
          </div>
          <div className={stile.skillsContainer}>
            {entwicklungsFaehigkeiten.map((kompetenz) => (
              <Skill
                key={kompetenz.id}
                title={kompetenz.title}
                logo={kompetenz.logo}
                experience={kompetenz.experience}
                diplom={kompetenz.diplom}
                setTech={setTech}
                showPopup={showPopup}
                setShowPopup={setShowPopup}
                setSelectedCardRect={setSelectedCardRect}
              />
            ))}
          </div>
        </div>
      )}

      {/* Systemadministrations-Bereich */}
      {(aktiveKategorie === 'all' || aktiveKategorie === 'administration') && (
        <div className={stile.categoryBlock}>
          <div className={stile.categoryHeader}>
            <h3 className={stile.categoryTitle}>
              <span className={stile.categoryIcon}><AdministrationIcon groesse={22} /></span>
              <span>{t('skills.kategorieAdministration')}</span>
            </h3>
            <span className={stile.categoryBadge}>{administrationsFaehigkeiten.length} {t('skills.technologien')}</span>
          </div>
          <div className={stile.skillsContainer}>
            {administrationsFaehigkeiten.map((kompetenz) => (
              <Skill
                key={kompetenz.id}
                title={kompetenz.title}
                logo={kompetenz.logo}
                experience={kompetenz.experience}
                diplom={kompetenz.diplom}
                setTech={setTech}
                showPopup={showPopup}
                setShowPopup={setShowPopup}
                setSelectedCardRect={setSelectedCardRect}
              />
            ))}
          </div>
        </div>
      )}
    </section>
  );
}

export default Skills;
